import { DeleteOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Tooltip } from 'antd';
import React from 'react';
import { GraphQLTaggedNode, useMutation } from 'react-relay';

import useCommitTableRecord from '../hooks/useCommitTableRecord';

interface IActionButtonDelete {
    id: string;
    connectionId: string;
    mutationDelete: GraphQLTaggedNode;
}

const ActionButtonDelete: React.FC<IActionButtonDelete> = ({ id, connectionId, mutationDelete }) => {
    const [commitDelete] = useMutation(mutationDelete);
    const { getCommitTableRecordDelete } = useCommitTableRecord();

    const onClickDelete = () => {
        commitDelete(getCommitTableRecordDelete(id, connectionId));
    };

    return (
        <Tooltip title="Delete">
            <Popconfirm
                title="Delete the record"
                description="Are you sure to delete this record?"
                onConfirm={onClickDelete}
                okText="Yes"
                cancelText="No"
            >
                {<Button shape="circle" icon={<DeleteOutlined />} danger />}
            </Popconfirm>
        </Tooltip>
    );
};

export default ActionButtonDelete;
